import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-section',
  templateUrl: './signup-section.component.html',
  styleUrls: ['./signup-section.component.scss']
})
export class SignupSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
